import {
  updateBlowerSettingService,
  updateSwitchSettingService,
} from '../../../services';

/**
 * Sends `{ target, deviceIds, body }` writes (see settingsPayloads) as
 * test-device setting updates, all at once.
 */
export const sendSettingWrites = (writes) =>
  Promise.all(
    writes.map(({ target, deviceIds, body }) =>
      target === 'switches'
        ? updateSwitchSettingService(deviceIds, body, true)
        : updateBlowerSettingService(deviceIds, body, true),
    ),
  );
